import { createContext, useContext, useMemo, type ReactNode } from "react";
import { APP_VERSION } from "@/config/appInfo";
import { ChangelogEntry, getChangelogEntries } from "@/lib/whatsNew";

interface WhatsNewContextValue {
  entries: ChangelogEntry[];
  currentVersion: string;
  open: boolean;
  openModal: () => void;
  closeModal: () => void;
  dismissCurrentVersion: () => void;
}

const WhatsNewContext = createContext<WhatsNewContextValue | undefined>(undefined);

export const WhatsNewProvider = ({ children }: { children: ReactNode }) => {
  const entries = useMemo(() => getChangelogEntries(), []);
  const dismissCurrentVersion = () => {};

  const value: WhatsNewContextValue = {
    entries,
    currentVersion: APP_VERSION,
    open: false,
    openModal: () => {},
    closeModal: () => {},
    dismissCurrentVersion,
  };

  return (
    <WhatsNewContext.Provider value={value}>{children}</WhatsNewContext.Provider>
  );
};

export const useWhatsNew = () => {
  const context = useContext(WhatsNewContext);

  if (!context) {
    throw new Error("useWhatsNew must be used within a WhatsNewProvider");
  }

  return context;
};
